import { z } from 'zod';
/** Papéis dentro de uma empresa. O superadmin Smile é um atributo do usuário, fora desta lista. */
export const TenantRoleSchema = z.enum(['TENANT_ADMIN', 'OPERATOR', 'VIEWER']);
export const PermissionSchema = z.enum([
    'tenant:read',
    'tenant:update',
    'users:read',
    'users:manage',
    'groups:read',
    'groups:manage',
    'devices:read',
    'devices:manage',
    'commands:send',
    'policies:read',
    'policies:manage',
    'audit:read',
]);
/** Permissões mínimas por papel (princípio do menor privilégio). */
export const ROLE_PERMISSIONS = {
    TENANT_ADMIN: PermissionSchema.options,
    OPERATOR: [
        'tenant:read',
        'groups:read',
        'devices:read',
        'devices:manage',
        'commands:send',
        'policies:read',
    ],
    VIEWER: ['tenant:read', 'groups:read', 'devices:read', 'policies:read'],
};
/** Papéis que exigem MFA no login (além do superadmin, que sempre exige). */
export const MFA_REQUIRED_ROLES = ['TENANT_ADMIN'];
export function roleHasPermission(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
export function requiresMfa(opts) {
    return opts.isSuperadmin || opts.roles.some((r) => MFA_REQUIRED_ROLES.includes(r));
}
/** Política de senha: 12 a 128 caracteres. Sem regras de composição (NIST SP 800-63B). */
export const PasswordSchema = z.string().min(12).max(128);
export const EmailSchema = z.string().trim().toLowerCase().max(254).pipe(z.email());
//# sourceMappingURL=rbac.js.map